<template>
  <a
    href="https://cl.liquidswap.com/#/TGlxdWlkc3dhcCB2MSAjNCAiZG9vZG9vIi0iUkVUdVJEIi0iWDgwIg=="
    rel="noopener noreferrer"
    role="button"
    target="_blank"
  >
    <div :class="[`returd-banner-${stylesVariant}`]" @click="trackLink">
      <div :class="[`returd-banner-${stylesVariant}__background-gradient`]">
        <img
          alt="background"
          class="image-gradient"
          src="@/assets/banners/purple-background.svg"
        />
      </div>
      <img
        :class="[`returd-banner-${stylesVariant}__logo`]"
        alt="returd-and-doodoo-coin"
        src="@/assets/banners/returd-banner.png"
      />
      <div :class="[`returd-banner-${stylesVariant}__item`]">
        <p :class="[`returd-${stylesVariant}`]">{{ $t('swap.returd') }}</p>
        <p :class="[`doodoo-${stylesVariant}`]">{{ $t('swap.doodoo') }}</p>
      </div>
      <div class="returd-banner-full__item">
        <p v-if="!props.sideDrawer" class="available">
          {{ $t('swap.availableOnLiquidSwap') }}
        </p>
        <a
          v-if="props.sideDrawer"
          href="https://cl.liquidswap.com/#/TGlxdWlkc3dhcCB2MSAjNCAiZG9vZG9vIi0iUkVUdVJEIi0iWDgwIg=="
          rel="noopener noreferrer"
          role="button"
          target="_blank"
        >
          <p-button
            :class="[`returd-banner-${stylesVariant}__action-button`]"
            @click="onClose"
          >
            {{ $t('swap.goToSwap') }}
          </p-button>
        </a>
      </div>
    </div>
  </a>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue';
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { Track } from '@/types';

const props = defineProps({
  sideDrawer: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const emits = defineEmits(['cancel']);

const stylesVariant = computed(() => {
  return props.sideDrawer ? 'short' : 'full';
});

const track = inject(EMixpanelProvideKeys.Track) as Track;

const trackLink = () => {
  track(EMixpanelEventNames.BannerReturd);
};

function onClose() {
  emits('cancel');
}
</script>

<style lang="scss" scoped>
.returd-banner-full {
  display: flex;
  width: 100%;
  height: 84px;
  gap: 17px;
  align-items: center;
  position: relative;
  border-radius: 10px;
  background: #abaeff21;

  @media (max-width: 500px) {
    gap: 10px;
  }

  &__item {
    z-index: 2;
  }

  &__logo {
    z-index: 2;
    margin-top: 5px;
    margin-left: 25px;
    min-width: 90px;

    @media (max-width: 500px) {
      margin-top: 0;
      margin-left: 10px;
      min-width: 65px;
    }
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 84px;
  }
}

.returd-banner-short {
  display: flex;
  position: relative;
  width: 100%;
  height: 51px;
  margin-bottom: 10px;
  align-items: center;
  border-radius: 10px;
  background: #abaeff21;
  overflow: hidden;

  &__item {
    z-index: 2;
    display: flex;
  }

  &__logo {
    z-index: 2;
    left: 15px;
    top: 0;
    width: 80px;
    position: absolute;

    @media (max-width: 500px) {
      left: 5px;
      width: 80px;
    }
  }

  &__action-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #5ff8d233;
    border: 1px solid #5ff8d2;
    border-radius: 51px;
    padding: 5px 15px;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;

    &:hover {
      border-color: #5ff8d2;
      background: #5ff8d444;
    }

    @media (max-width: 500px) {
      font-size: 10px;
      padding: 6px;
    }
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 51px;
    opacity: 0.7;
    transform: rotateX(180deg);
    background: radial-gradient(
      46.65% 93.31% at 49.27% 106.09%,
      #5c308e 25.09%,
      rgba(55, 44, 123, 0.5) 76.41%,
      rgba(53, 42, 119, 0.3999) 81.13%,
      rgba(46, 37, 106, 0.2962) 86.02%,
      rgba(35, 28, 86, 0.1909) 90.99%,
      rgba(19, 15, 57, 0.0851) 95.99%,
      rgba(3, 3, 28, 0) 100%
    );
  }
}

.returd-full {
  font-family: Work Sans, sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0;
  color: #5ff8d2;
  font-size: 26px;
  line-height: 29px;

  @media (max-width: 500px) {
    font-size: 16px;
  }
}

.returd-short {
  font-family: Work Sans, sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 0 100px;
  color: #5ff8d2;
  font-size: 22px;
  line-height: 24px;

  @media (max-width: 500px) {
    font-size: 16px;
    margin: 0 0 0 100px;
  }

  @media (max-width: 410px) {
    font-size: 16px;
    margin: 0 0 0 90px;
  }
}

.doodoo-full {
  font-family: Work Sans, sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  color: #ffffff;
  font-size: 26px;
  line-height: 29px;
  margin: -5px 0 0;

  @media (max-width: 500px) {
    font-size: 20px;
  }
}

.doodoo-short {
  font-family: Work Sans, sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  color: #ffffff;
  font-size: 22px;
  line-height: 24px;
  margin: 0 10px 0;

  @media (max-width: 500px) {
    font-size: 16px;
  }
}

.available {
  margin: 0 0 8px;
  font-family: Work Sans, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0;
  color: #ffffff;

  @media (min-width: 500px) {
    margin-left: 10px;
  }

  @media (max-width: 385px) {
    font-size: 12px;
  }
}

.image-gradient {
  width: 100%;
}
</style>
